import { GameCard } from './main.entity';

export const GAME_CARDS: GameCard[] = [
  {
    title: $localize`:@@main.modes.wheel:Wheel`,
    mode: 'wheel',
    badge: 'pve',
    routerLink: '/wheel'
  },
  {
    title: $localize`:@@main.modes.crash:Сrash`,
    mode: 'crash',
    badge: 'pve',
    routerLink: '/crash'
  },
  {
    title: $localize`:@@main.modes.double:Double`,
    mode: 'double',
    badge: 'pve',
    routerLink: '/double'
  },
  {
    title: $localize`:@@main.modes.jackpot:Jackpot`,
    mode: 'jackpot',
    badge: 'pvp',
    routerLink: '/jackpot'
  },
  {
    title: $localize`:@@main.modes.mines:Mines`,
    mode: 'mines',
    badge: 'pve',
    isHot: true,
    routerLink: '/mines'
  },
  {
    title: $localize`:@@main.modes.super-wheel:Crazy Wheel`,
    mode: 'super_wheel',
    badge: 'pve',
    isNew: true,
    routerLink: '/crazy-wheel'
  },
  {
    title: $localize`:@@main.modes.defuse:Defuse`,
    mode: 'defuse',
    badge: 'pve',
    routerLink: '/defuse'
  }
];
